import React from 'react';
import { useTimeFormatter, TimeDetails } from '@/utils/timeFormatter';
import { FlipDigit } from './FlipDigit';
import styles from './FlipTimeDisplay.module.css';

interface FlipTimeDisplayProps {
  endDate: string;
}

const splitDigits = (num: number): string[] => {
  return String(num).padStart(2, '0').split('');
};

export const FlipTimeDisplay: React.FC<FlipTimeDisplayProps> = ({
  endDate,
}) => {
  const time = useTimeFormatter(endDate, 'detail');

  if (typeof time === 'string') {
    return <div className={styles.message}>{time}</div>;
  }

  const t = time as TimeDetails;

  return (
    <div className={styles.container}>
      <div className={styles.timeBlock}>
        <span className={styles.unit}>дней</span>
        <div className={styles.digits}>
          {splitDigits(t.days).map((d, i) => (
            <FlipDigit key={`d${i}`} value={d} />
          ))}
        </div>
      </div>

      <div className={styles.timeBlock}>
        <span className={styles.unit}>часов</span>
        <div className={styles.digits}>
          {splitDigits(t.hours).map((h, i) => (
            <FlipDigit key={`h${i}`} value={h} />
          ))}
        </div>
      </div>

      <div className={styles.timeBlock}>
        <span className={styles.unit}>минут</span>
        <div className={styles.digits}>
          {splitDigits(t.minutes).map((m, i) => (
            <FlipDigit key={`m${i}`} value={m} />
          ))}
        </div>
      </div>

      {/* <div className={styles.timeBlock}>
        <span className={styles.unit}>секунд</span>
        <div className={styles.digits}>
          {splitDigits(t.seconds).map((s, i) => (
            <FlipDigit key={`s${i}`} value={s} />
          ))}
        </div>
      </div> */}
    </div>
  );
};
